import React from 'react';
import { Syringe, Sparkles, Sun, ArrowUp, Eye, Droplet } from 'lucide-react';
export function ServicesSection() {
  const services = [{
    title: 'Injectables',
    description: 'Botox, Dysport, Jeuveau, Dermal Fillers',
    icon: <Syringe className="w-8 h-8 text-[#C8A84E]" data-id="element-132" />
  }, {
    title: 'Facials',
    description: 'Classic, Anti-Aging, HydraFacials, LED Light Therapy',
    icon: <Sparkles className="w-8 h-8 text-[#C8A84E]" data-id="element-133" />
  }, {
    title: 'Skin Rejuvenation',
    description: 'Microneedling, PRP, Chemical Peels',
    icon: <Sun className="w-8 h-8 text-[#C8A84E]" data-id="element-134" />
  }, {
    title: 'PDO Thread Lifts',
    description: 'Non-surgical lifting and tightening',
    icon: <ArrowUp className="w-8 h-8 text-[#C8A84E]" data-id="element-135" />
  }, {
    title: 'Lash & Brow',
    description: 'Extensions, Lifts, Lamination, Tinting, Microblading',
    icon: <Eye className="w-8 h-8 text-[#C8A84E]" data-id="element-136" />
  }, {
    title: 'Spray Tans & IV Therapy',
    description: 'Custom tans, Vitamin & Hydration IVs',
    icon: <Droplet className="w-8 h-8 text-[#C8A84E]" data-id="element-137" />
  }];
  return <section id="services" className="bg-[#0A0A0A] py-20 md:py-28" data-id="element-138">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-139">
        <div className="text-center mb-16" data-id="element-140">
          <span className="text-[#C8A84E] text-sm tracking-[0.2em] uppercase font-semibold mb-4 block" style={{
          fontFamily: "'Montserrat', sans-serif"
        }} data-id="element-141">
            Our Services
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl text-white leading-tight" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-142">
            Treatments Tailored to You
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-143">
          {services.map((service, index) => <div key={index} className="bg-[#1A1A1A] rounded-xl p-8 border-t-2 border-[#C8A84E] transition-all duration-300 hover:-translate-y-2 hover:shadow-[0_10px_30px_rgba(200,168,78,0.15)] group flex flex-col h-full" data-id="element-144">
              <div className="mb-6 bg-[#0A0A0A] w-16 h-16 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300" data-id="element-145">
                {service.icon}
              </div>
              <h3 className="text-xl text-white font-semibold mb-3" style={{
            fontFamily: "'Montserrat', sans-serif"
          }} data-id="element-146">
                {service.title}
              </h3>
              <p className="text-gray-400 mb-8 flex-grow" style={{
            fontFamily: "'Montserrat', sans-serif"
          }} data-id="element-147">
                {service.description}
              </p>
              <a href={`#service-${index}`} className="inline-flex items-center text-[#C8A84E] font-medium hover:underline underline-offset-4 transition-all mt-auto" style={{
            fontFamily: "'Montserrat', sans-serif"
          }} data-id="element-148">
                Learn More{' '}
                <span className="ml-2 group-hover:translate-x-1 transition-transform" data-id="element-149">
                  →
                </span>
              </a>
            </div>)}
        </div>
      </div>
    </section>;
}